import React, { useContext, useEffect, useState } from "react";
import CheckListFBYInput from "../../../../blocks/FormItems/CheckListFBYInput";
import { psychologistDiagnosisOptions } from "../../Options/psychologistOptions";

const PsychologistDiagnosis = ({ form, context }) => {
  const { formData } = useContext(context);
  const [checkboxes, setCheckboxes] = useState({});
  useEffect(() => {
    const diagnosis = formData?.psychology_diagnosis || {};
    // Flatten nested shape if previously double-wrapped on save
    const values =
      diagnosis?.psychology_diagnosis &&
      typeof diagnosis.psychology_diagnosis === "object"
        ? diagnosis.psychology_diagnosis
        : diagnosis;
    form.setFieldsValue(values);
    const initialCheckboxes = psychologistDiagnosisOptions.reduce(
      (acc, checkbox) => {
        acc[checkbox.value] = values?.[checkbox.value] || false;
        return acc;
      },
      {}
    );
    setCheckboxes(initialCheckboxes);
  }, [formData, form]);
  return (
    <CheckListFBYInput
      checkboxes={checkboxes}
      setCheckboxes={setCheckboxes}
      options={psychologistDiagnosisOptions}
      others_key={"others"}
      form={form}
      field_key={"others"}
    />
  );
};

export default PsychologistDiagnosis;
